import { observable } from 'mobx';
import { SerializedData, Store } from 'bernie-core';
import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';
import FlightsJourneyDetailsDynamicElements = FlightsShoppingPwaFlightInformationResults.FlightsJourneyDetailsDynamicElements;
import DynamicElementsGroups = FlightsShoppingPwaFlightInformationResults.DynamicElementsGroups;
import { FlightsLoadedPriceSummaryType } from 'types/information/price-summary/price-summary';
import DynamicElements = FlightsShoppingPwaFlightInformationResults.DynamicElements;

export class DynamicElementsStore extends Store {
  @observable public dynamicElementsGroups: DynamicElementsGroups[];
  public dynamicElementsMap: Map<string, DynamicElements>;

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public initialiseDynamicStoreCache() {
    if (this.dynamicElementsGroups && this.dynamicElementsGroups.length > 0) {
      this.dynamicElementsMap = new Map();
      this.dynamicElementsGroups.map(element => {
        this.dynamicElementsMap.set(element.identifier, element.dynamicElements);
      });
    }
  }

  public getPriceSummaryById(identifier: string): FlightsLoadedPriceSummaryType {
    if (this.dynamicElementsMap && this.dynamicElementsMap.has(identifier)) {
      return this.dynamicElementsMap.get(identifier).priceSummary;
    }
  }

  public getFlightsJourneyDetailsById(identifier: string): FlightsJourneyDetailsDynamicElements[] {
    if (this.dynamicElementsMap && this.dynamicElementsMap.has(identifier)) {
      return this.dynamicElementsMap.get(identifier).flightsJourneyDetailsDynamicElements;
    }
  }
}
